import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import FieldType from 'app/admin/dataset/dto/FieldType';
import UnitOptimizerLogEditService from '../service/UnitOptimizerLogEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'unitOptimizerLogEditForm',
		topic: 'unitOptimizerLog',
		service: UnitOptimizerLogEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'table_name',
					component: EditFormTextField
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				}
			];

			return fields;
		}
	};
};

function UnitOptimizerLogEditForm() {
	const { id } = useParams();
	const dispatch = useDispatch();
	const myConfig = config({ id });
	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(UnitOptimizerLogEditForm);